// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"5b09a291","116":"6d8d9fc6","748":"f53f2765","877":"b34e886e","933":"f792af73"}[chunkId] + ".css";
};